import Api from "./Api";

class CountryDataService {
    getAll = () => {
        return Api().get('countries')
    }

    get = id => {
        return Api().get(`country/${id}`)
    }

    put = async (id, country) => {
        return await Api().put(`country/${id}`, {
            af0_start_date: country.af0_start_date
        })
    }
}

export default new CountryDataService();